import axios, { AxiosError, type AxiosInstance } from 'axios';

import {
  getRefreshedToken,
  GoogleOAuthStorage,
  GoogleOAuthUnauthorizedError,
} from '../google';

import { GOOGLE_CLASSROOM_API_BASE_URL } from './constants';

export const createGoogleClassroomApiClient = (): AxiosInstance => {
  const axiosInstance = axios.create({
    baseURL: GOOGLE_CLASSROOM_API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  axiosInstance.interceptors.response.use(
    response => response,
    async error => {
      if (error instanceof AxiosError && error.response?.status === 401) {
        const newAccessToken = await getRefreshedToken();
        if (newAccessToken == null) {
          throw new GoogleOAuthUnauthorizedError();
        }
        GoogleOAuthStorage.setToken(newAccessToken);

        // retry with new token
        console.warn('retry with new token...');
        if (error.config != null) {
          error.config.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance.request(error.config);
        }

        throw new GoogleOAuthUnauthorizedError();
      }
      throw error;
    },
  );

  return axiosInstance;
};

export const googleClassroomApiClient = createGoogleClassroomApiClient();
